import React, { useEffect } from 'react'

// third-party
import { Button, Modal } from 'react-bootstrap'
import { GoogleAnalyticsEnum, pageView } from '../../utils/google-analytics';

function CommentDeleteModal({ isDeleting = false, closeModalDeleteComment = () => { }, openModalDeleteComment = () => { } }) {

    useEffect(() => {
        pageView(window.location.href, GoogleAnalyticsEnum.LSA_SALESFORCE_COMMENT_DELETE_MODAL_OPENED);
    }, []);

    return (
        <>
            {/* Delete modal  */}
            <Modal show={isDeleting} aria-labelledby="contained-modal-title-vcenter" onHide={closeModalDeleteComment} centered size='lg'>
                <Modal.Header closeButton className='border-0 px-5 pb-0'>
                    <Modal.Title className="h6 mb-0" text id="contained-modal-title-vcenter">Delete Comment</Modal.Title>
                </Modal.Header>
                <Modal.Body className='px-5 pb-0'>
                    <p className='fs-3 textfw-normal'>
                        Are You sure you want to delete the comment? You cannot undo this action.
                    </p>
                </Modal.Body>
                <Modal.Footer className='border-0 px-5 pt-0'>
                    <Button
                        className={"rn-btn py-2 px-4 rounded-pill fs-3 text fw-bold"}
                        onClick={openModalDeleteComment}
                        variant='danger'
                    >
                        Delete
                    </Button>
                    <Button type="button" pattern="white" className={"rn-btn comment-btn cancel-btn ml--15 rounded-pill fs-3 text fw-bold"} onClick={closeModalDeleteComment}>
                        Cancel
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CommentDeleteModal
